import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent} from './confirm-dialog/confirm-dialog.component';
import {CordovaService} from '../../cordova.service';

@Injectable({
    providedIn: 'root'
})
export class ConfirmDialogService {

    private prevBackFunction: Function;

    constructor(public dialog: MatDialog,
                private cordovaService: CordovaService) {
    }

    closeAll() {
        this.dialog.closeAll();
    }

    confirm(title, text, confirm = 'Oké', cancel = 'Annuleren'): Promise<void> {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            panelClass: 'confirm-dialog',
            disableClose: true,
            data: {
                title: title,
                text: text,
                confirm: confirm,
                cancel: cancel
            }
        });
        this.prevBackFunction = this.cordovaService.getCurrentBackFunction();
        this.cordovaService.setBackbuttonAction(() => {
            dialogRef.close();
        });

        return new Promise((resolve, reject) => {
            const subs = dialogRef.afterClosed().subscribe(result => {
                if (this.prevBackFunction) {
                    this.cordovaService.setBackbuttonAction(this.prevBackFunction);
                }
                if (result) {
                    resolve();
                } else {
                    reject();
                }
                subs.unsubscribe();
            });
        });
    }
}
